var render, staticRenderFns
import script from "./table-without-pagination.vue?vue&type=script&lang=js"
export * from "./table-without-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568d1b96')) {
      api.createRecord('568d1b96', component.options)
    } else {
      api.reload('568d1b96', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/table-without-pagination.vue"
export default component.exports